var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.6108 32.0832H11.4046C6.09622 32.0832 2.93164 28.9186 2.93164 23.6103V11.4041C2.93164 6.09573 6.09622 2.93115 11.4046 2.93115H23.6108C28.9191 2.93115 32.0837 6.09573 32.0837 11.4041V23.6103C32.0837 28.9186 28.9191 32.0832 23.6108 32.0832Z",
    fill: "#F45858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9306 14.3354C23.041 16.8729 20.6494 18.5791 17.966 18.5791C17.9514 18.5791 17.9514 18.5791 17.9368 18.5791L14.9327 18.5646C14.9327 18.5646 14.9327 18.5646 14.9181 18.5646C13.8097 18.5646 12.8472 19.3083 12.5556 20.3729C13.8535 20.7812 14.8015 21.9916 14.8015 23.4208C14.8015 25.1854 13.3577 26.6292 11.5931 26.6292C9.82853 26.6292 8.38477 25.1854 8.38477 23.4208C8.38477 22.1229 9.17225 21 10.2806 20.5041V14.175C9.17225 13.7375 8.38477 12.6583 8.38477 11.4042C8.38477 9.75624 9.72641 8.41455 11.3743 8.41455C13.0222 8.41455 14.3639 9.75624 14.3639 11.4042C14.3639 12.6729 13.5764 13.7375 12.4681 14.175V17.1208C13.1827 16.6687 14.0285 16.4062 14.9181 16.4062H14.9327L17.9368 16.4208C19.6577 16.4792 21.189 15.3708 21.8015 13.7667C21.0869 13.2125 20.6202 12.3667 20.6202 11.4042C20.6202 9.75624 21.9619 8.41455 23.6098 8.41455C25.2577 8.41455 26.5993 9.75624 26.5993 11.4042C26.6139 12.9208 25.4326 14.175 23.9306 14.3354Z",
    fill: "#F45858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab);
export default __webpack_public_path__ + "static/media/collab.510e3d293e42b2a7cce376b1c0ffc84b.svg";
export { ForwardRef as ReactComponent };